import VerticalCard from "../generic/VerticalCard";
import {useHistory} from "react-router-dom";
import {Col, Row} from "react-bootstrap";

// Pagina familia, muestra tarjetas que llevan a la pestana de cada organizacion
export const Familia = () => {
    const history = useHistory();
    return (
        <Row noGutters className={"justify-content-center"}>
            <Col className={"m-2"} xs={"auto"}>
                <VerticalCard
                    onClick={() => {
                        history.push("/familia/fet")
                    }}
                    cardImage={"/images/logoFET.png"}
                    imgOnError={"/images/logoSTJ.png"}
                    title={"Fundacion Escuela Teresiana"}
                />
            </Col>
            <Col className={"m-2"} xs={"auto"}>
                <VerticalCard
                    onClick={() => {
                        history.push("/familia/fundeo")
                    }}
                    cardImage={"/images/logoFUNDEO.png"}
                    imgOnError={"/images/logoSTJ.png"}
                    title={"Fundacion Enrique Osso"}
                />
            </Col>
            <Col className={"m-2"} xs={"auto"}>
                <VerticalCard
                    onClick={() => {
                        history.push("/familia/mta")
                    }}
                    cardImage={"/images/logoMTA.png"}
                    imgOnError={"/images/logoSTJ.png"}
                    title={"Movimiento Teresiano Apostólico"}
                />
            </Col>
        </Row>
    )
}